import React, { useEffect, useState } from 'react';
import { Dialog } from 'primereact/dialog';
import style from './AddDocument.module.css';
import { addReportivfCLinic, getClientDataById } from '../../../../Api/IvfClinic';
import moment from 'moment';
import ImageUpload from '../../../SurrogateComponents/Auction/CreatePostAuction/ImageUpload';
import { uploadImage } from '../../../../Api/SurrogateMotherApis';
import Loader from '../../../common/Loader';

const AddDocument = ({ addocument, setAddDocument, appointmentId, reload }) => {
    const [loader, setLoader] = useState(false);
    const [image, setImage] = useState(null);
    const [fieldValidation, setFieldValidation] = useState(false);

    console.log('appointmentId',appointmentId)
    const [data, setData] = useState({
        appointmentId: `${appointmentId}`,
        report_name: '',
        test_date: '',
        name: '',
        clientId: '',
        contact_number: '',
        email_address: '',
        client_type: '',
        services_requested: '',
        report_file: {
            fileName: '',
            fileUrl: ''
        }
    });

    const getClientDataByIdFunction = async () => {
        try {
            setLoader(true);
            const response = await getClientDataById(appointmentId);
            const clientData = response.data.data;
            clientData.date = moment(clientData.date).format('YYYY-MM-DD');

            setData((prevData) => ({
                ...prevData,
                ...clientData,
                services_requested: clientData.service_requested 
            }));
        } catch (error) {
            console.log(error);
        } finally {
            setLoader(false);
        }
    };

    const addReport = async (e) => {
        e.preventDefault();
        setLoader(true);
        if (image === null) {
            setFieldValidation(true);
            setLoader(false);
            return;
        }

        try {
            const imageDataupload = await uploadImage(image);
            const report_file = {
                fileName: imageDataupload.data.fileName,
                fileUrl: imageDataupload.data.fileLocation
            };

            const updatedData = {
                ...data,
                report_file
            };

            await addReportivfCLinic(updatedData);
            reload();
            resetForm();
            setAddDocument(false);
        } catch (err) {
            console.log(err);
            setLoader(false);
        }
        finally{
            setLoader(false)
        }
    };

    const resetForm = () => {
        setData({
            appointmentId: `${appointmentId}`,
            report_name: '',
            test_date: '',
            name: '',
            clientId: '',
            contact_number: '',
            email_address: '',
            client_type: '',
            services_requested: '',
            report_file: {
                fileName: '',
                fileUrl: ''
            }
        });
        setImage(null);
        setFieldValidation(false);
    };

    const onInputChange = (e) => {
        const { name, value } = e.target;
        setData((prevData) => ({ ...prevData, [name]: value }));
        setFieldValidation(false);
    };

    useEffect(() => {
        if (addocument) {
            getClientDataByIdFunction();
        }
    }, [addocument]);

    return (
        <div>
            <Loader open={loader} />
            <Dialog
                closable={false}
                visible={addocument}
                className='p-0 m-0'
                onHide={() => setAddDocument(false)}
                style={{ width: '70vw', padding: '0px', margin: '0px' }}
                breakpoints={{ '1400px': '80vw', '641px': '100vw' }}
            >
                <div className='Verfied_con'>
                    <div className='d-flex justify-content-center '>
                        <span className={`fW_600 ${style.verfideText}`}>Upload Report</span>
                    </div>

                    <form onSubmit={addReport}>
                        <div className='row'>
                            <div className='col-md-4 mt-3'>
                                <label className={`form-check-label mb-1 ${style.LabelText}`} htmlFor='report_name'>Report Name</label>
                                <input
                                    name='report_name'
                                    required
                                    type='text'
                                    className='form-control'
                                    placeholder='Enter Report Name'
                                    onChange={onInputChange}
                                    value={data.report_name}
                                />
                            </div>
                            <div className='col-md-4 mt-3'>
                                <label className={`form-check-label mb-1 ${style.LabelText}`} htmlFor='test_date'>Test Date</label>
                                <input
                                    name='test_date'
                                    required
                                    type='date'
                                    className='form-control'
                                    placeholder='Enter Test Date'
                                    onChange={onInputChange}
                                    value={data.test_date}
                                />
                            </div>
                            <div className='col-md-4 mt-3'>
                                <label className={`form-check-label mb-1 ${style.LabelText}`} htmlFor='services_requested'>Service Requested</label>
                                <input
                                    disabled
                                    type='text'
                                    className='form-control'
                                    value={data.services_requested}
                                />
                            </div>
                        </div>
                        <div className='row'>
                            <div className='col-md-4 mt-3'>
                                <label className={`form-check-label mb-1 ${style.LabelText}`} htmlFor='email_address'>Email Address</label>
                                <input
                                    disabled
                                    type='email'
                                    className='form-control'
                                    value={data.email_address}
                                />
                            </div>
                            <div className='col-md-4 mt-3'>
                                <label className={`form-check-label mb-1 ${style.LabelText}`} htmlFor='contact_number'>Contact Number</label>
                                <input
                                    disabled
                                    type='tel'
                                    className='form-control'
                                    value={data.contact_number}
                                />
                            </div>
                            <div className='col-md-4 mt-3'>
                                <label className={`form-check-label mb-1 ${style.LabelText}`} htmlFor='client_type'>Client Type</label>
                                <input
                                    disabled
                                    type='text'
                                    className='form-control'
                                    value={data.client_type}
                                />
                            </div>
                        </div>
                        
                        <div className='my-5 d-flex flex-column gap-2'>
                            <div onClick={() => setFieldValidation(false)}>
                                <ImageUpload image={image} setImage={setImage} allowedFileTypes={["image/jpeg", "image/png", "application/pdf"]} />
                            </div>
                            {fieldValidation && (
                                <div className='d-flex justify-content-center' role='alert'><span className='w-50 alert alert-danger text-center'>Please select an image or PDF to upload</span></div>
                            )}
                        </div>
                        <div className='d-flex justify-content-end gap-3'>
                            <button className={style.CencelButton} type='button' onClick={() => {setAddDocument(false); resetForm()}}>Cancel</button>
                            <button className={style.SubmitButton} type='submit' disabled={loader}>Upload</button>
                        </div>
                    </form>
                </div>
            </Dialog>
        </div>
    );
};

export default AddDocument;
